import { LossDriversPage } from "@/components/investigations/LossDriversPage";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated/loss-drivers/")({
  component: LossDriversPage,
});
